// extracted by mini-css-extract-plugin
export var discard = "_5k-3";
export var muiTooltipTooltip = "_5k-5";
export var notificationBar = "_5k-2";
export var saveButtonHoverSlotWrapper = "_5k-4";
export var show = "_5k-1";
export var spacer = "_5k-0";